export class ListAzureVirtualNetworks200ResponseVirtualNetworksInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "addressPrefixes",
            "baseName": "addressPrefixes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureVirtualNetworks200ResponseVirtualNetworksInner.attributeTypeMap;
    }
    constructor() {
    }
}
